import TextInput from "../components/form/TextInput";
import {ifCompletedInput} from "./other";
import React from "react";
import Select from "../components/form/Select";

export const qty = (props) => {
    const {field = "qty"} = props || {};
    return (parent) =>
        (props, value) =>
            <TextInput
                type="decimal"
                name={field}
                label={false}
                focus
                value={value}
                onKeyDown={(e, field, value) => {
                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                }}
                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
            />;
}

export const price = (props) => {
    const {field = "price"} = props || {};
    return (parent) =>
        (props, value) =>
            <TextInput
                name={field}
                label={false}
                focus
                value={value}
                onKeyDown={(e, field, value) => {
                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                }}
                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
            />;
}

export const vat = (props) => {
    const {field = "vat"} = props || {};
    return (parent) =>
        (props, value) =>
            <Select
                name={field}
                component="vatrate"
                filter={{field: "active", value: 1}}
                objectValue={true}
                label={false}
                storeType="local"
                value={value}
                view={["rate"]}
                saveChanges={(field, value) => {
                    parent.onEditorValueChange(props, value);
                }}
            />;
}